import React from "react";

const DCDialLogoBig = (props: any) => {
  return (
    <svg width={215} height={60} viewBox="0 0 215 60" fill="none" {...props}>
      <g id="DCDial Logo 1" clipPath="url(#clip0_1876_35830)">
        <g id="Group">
          <path
            id="Vector"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M89.7714 26.6292C91.5452 26.2584 93.2204 27.0337 94.3044 28.2472C96.5053 30.8427 96.9323 41.6292 90.8225 42.1685C83.2345 42.8764 82.8404 28.0449 89.7714 26.6292ZM95.5855 23.4944C95.1585 22.8876 93.2861 20.8315 90.1984 20.3595C87.7019 19.955 84.3842 20.7303 82.5776 22.0112C72.1975 29.3595 76.205 52.1124 90.3955 48.2022C93.2204 47.427 95.2899 44.9326 95.5198 44.5618L95.5855 47.7977L103.502 47.8314V8.02246H95.5855V23.4944Z"
            fill="#848182"
          />
          <path
            id="Vector_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M193.247 34.9886C194.364 40.4493 189.437 45.0673 185.922 41.7976C184.279 40.2471 184.674 37.4493 186.546 36.337C187.466 35.7976 191.933 35.0561 193.247 34.9886ZM180.239 22.4156L180.141 28.4156C181.389 27.8089 181.29 27.8763 183.36 26.9662C184.542 26.4606 185.988 26.0561 187.4 25.9212C190.783 25.6516 193.411 26.3931 193.346 30.101C191.112 31.2808 185.363 30.91 182.407 32.3594C172.224 37.3482 179.089 52.8875 189.634 47.5617C191.933 46.4156 191.867 45.4718 193.346 44.2583L193.411 47.7639H200.769C200.769 43.5504 200.769 39.3707 200.769 35.1572C200.769 30.8089 201.131 27.4044 199.061 24.2358C195.349 18.5729 185.561 19.9212 180.239 22.4156Z"
            fill="#848182"
          />
          <path
            id="Vector_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M129.355 46.7866L129.388 40.4832C128.107 40.5843 125.019 43.3146 120.88 41.7641C112.11 38.5281 116.676 22.2472 127.581 27.472C128.238 27.7416 128.6 27.9439 129.388 28.2472V21.5731C125.151 19.4495 118.581 19.8203 114.475 22.3484C106.723 27.1349 105.507 41.0899 114.409 46.6854C118.022 48.9776 125.709 49.3484 129.355 46.7866Z"
            fill="#848182"
          />
          <path
            id="Vector_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M206.582 47.7303H214.466L214.433 8.05615H206.582V47.7303Z"
            fill="#848182"
          />
          <path
            id="Vector_5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M165.391 47.7303H173.406V21.0337H165.391C165.391 24.8764 165.391 45.7416 165.391 47.7303Z"
            fill="#848182"
          />
          <path
            id="Vector_6"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.3307 0.0336914L56.0365 2.39324L43.1928 15.7416H15.4359L2.625 2.39324L29.3307 0.0336914Z"
            fill="#FDD12F"
          />
          <path
            id="Vector_7"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.3307 59.8987L2.625 57.6066L15.4359 44.2583H43.1928L56.0365 57.6066L29.3307 59.8987Z"
            fill="#39C84F"
          />
          <path
            id="Vector_8"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.128906 29.9998L2.62538 2.39307L15.4363 15.7414V44.2582L2.62538 57.6065L0.128906 29.9998Z"
            fill="var(--color-blue2)"
          />
          <path
            id="Vector_9"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M58.4659 30.0003L56.0351 2.39355L43.1914 15.7419V44.2587L56.0351 57.607L58.4659 30.0003Z"
            fill="#C51F25"
          />
          <path
            id="Vector_10"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M169.365 16.4831C171.598 16.4831 173.405 14.6291 173.405 12.337C173.405 10.0449 171.598 8.19092 169.365 8.19092C167.131 8.19092 165.324 10.0449 165.324 12.337C165.324 14.6291 167.131 16.4831 169.365 16.4831Z"
            fill="#848182"
          />
          <path
            id="Vector_11"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M145.648 26.6292C147.422 26.2584 149.097 27.0337 150.181 28.2472C152.382 30.8427 152.809 41.6292 146.699 42.1685C139.078 42.8764 138.684 28.0449 145.648 26.6292ZM151.429 23.4944C151.002 22.8876 149.13 20.8315 146.042 20.3595C143.546 19.955 140.228 20.7303 138.421 22.0112C128.041 29.3595 132.049 52.1124 146.239 48.2022C149.064 47.427 151.134 44.9326 151.396 44.5618L151.462 47.7977L159.379 47.8314V8.02246H151.429V23.4944Z"
            fill="#848182"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1876_35830">
          <rect width={214.5} height={60} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DCDialLogoBig;
